<section class="router-container">
    <router-outlet></router-outlet>
</section>
